import style from './teaser-focus.scss';
import image from './teaser-focus.jpg';

const script = ()=> {
  const cssClass: string = 'TeaserFocus';
  const target: string = `.${cssClass} iframe`;
  const targets: any = document.querySelectorAll(target);
  let idInterval: ReturnType<typeof setInterval>;
  let intervalIsLaunchOnce: boolean = false;
  let nbIframeClicked: number = 0;
  const checkFocus = () => {
    for (const elt of targets) {
      if(document.activeElement === elt) {
        const container = elt.closest(`.${cssClass}`);
        container.classList.add(`${cssClass}--isClicked`);
        nbIframeClicked++;
        if(nbIframeClicked === targets.length) {
          clearInterval(idInterval);
        }
      }
    }
  }

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    // excute only once
    if (intervalIsLaunchOnce === false) {
      intervalIsLaunchOnce = true;
      idInterval = setInterval(checkFocus, 1000);
    }
  }

};

export {
  style,
  image,
  script,
};
